import * as React from 'react'
import type { SVGProps } from 'react'
const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={54}
    height={42}
    viewBox="0 0 54 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 13.3542V0.586389C0 0.262535 0.262535 0 0.586388 0H14.8102C14.9926 0 15.1646 0.0848363 15.2755 0.229537L29.8764 19.2679C29.9874 19.4126 30.1593 19.4974 30.3417 19.4974H32.9001C33.2239 19.4974 33.4865 19.2349 33.4865 18.911V5.10811V0.586389C33.4865 0.262535 33.749 0 34.0729 0H53.2148C53.5386 0 53.8012 0.262536 53.8012 0.58639V22.5027C53.8012 22.8265 53.5386 23.0891 53.2148 23.0891H42.8797C42.5558 23.0891 42.2933 23.3516 42.2933 23.6754V36.576V41.4137C42.2933 41.7375 42.0307 42.0001 41.7069 42.0001H23.0773C22.8994 42.0001 22.7311 41.9193 22.6198 41.7804L0.128841 13.721C0.0454454 13.6169 0 13.4876 0 13.3542Z"
      fill="#4F5277"
    />
  </svg>
)
export default SvgLogo
